import { render, staticRenderFns } from "./ProfileAdvisor.vue?vue&type=template&id=08f7e3cd&scoped=true&"
import script from "./ProfileAdvisor.vue?vue&type=script&lang=js&"
export * from "./ProfileAdvisor.vue?vue&type=script&lang=js&"
import style0 from "./ProfileAdvisor.vue?vue&type=style&index=0&id=08f7e3cd&prod&scoped=true&lang=css&"
import style1 from "./ProfileAdvisor.vue?vue&type=style&index=1&id=08f7e3cd&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f7e3cd",
  null
  
)

export default component.exports